import request from "project-config/services/request/request";
import { useEffect, useState } from "react";
import { createContainer } from "unstated-next";
import { Project, IdeptInfo } from "../types";

export function useProjectStoreHook() {
  const [projectList, setProjectList] = useState<Project.Info[]>();
  const [subDingtalkDatas, setSubDingtalkDatas] = useState<IdeptInfo[]>([]);
  const [originDingTalkData, setOriginDingTalkData] = useState<IdeptInfo[]>([]);
  const [sumbitLoading, setSumbitLoading] = useState(false);

  async function fetchProjectData() {
    const res = await request.post(
      "/api/rendering/task/common/queryProjectAllInfo"
    );
    if (res.result) {
      setProjectList(res.data);
    }
  }

  useEffect(() => {
    fetchProjectData();
  }, []);

  return {
    projectList,
    setProjectList,
    fetchProjectData,
    subDingtalkDatas,
    setSubDingtalkDatas,
    originDingTalkData,
    setOriginDingTalkData,
    sumbitLoading,
    setSumbitLoading,
  };
}

const ProjectStoreContainer = createContainer(useProjectStoreHook);

export const ProjectStoreProvider = ProjectStoreContainer.Provider;

export function useProjectStore() {
  return ProjectStoreContainer.useContainer();
}
